import React from 'react';
import paper from '../ReportPaper.module.css';
import ThermographyTable from '../../../../pages/appointment/components/thermography/ThermographyTable';
import styles from '../../../../pages/appointment/components/thermography/thermography.module.css';
import { formatDate, formatTemp, formatThreshold } from '../../../../pages/appointment/modules/thermography/thermography';

/**
 * Miolo do PDF da termografia: contexto do exame (temperatura da sala,
 * locais, assimetrias), a tabela por região com delta T e, quando houver, a
 * comparação com a avaliação anterior. Só tabela e texto, sem figura.
 *
 * Recebe o job de buildThermographyJob.
 */
const ThermographyReportBody = ({ record, previous, groups, sites, asymmetries }) => {
  const context = [
    record.ambientTemp != null && `Temperatura da sala: ${formatTemp(record.ambientTemp)} °C`,
    `${sites} ${sites === 1 ? 'local avaliado' : 'locais avaliados'}`,
    `${asymmetries} ${asymmetries === 1 ? 'assimetria' : 'assimetrias'} acima de ${formatThreshold()} °C`,
    previous && `Comparado com a avaliação de ${formatDate(previous.measuredAt)}`,
  ].filter(Boolean);

  return (
    <>
      <div className={paper.section}>
        <div className={paper.noteBox}>{context.join(' · ')}</div>
      </div>

      <div className={paper.section}>
        <div className={paper.sectionTitle}>Temperaturas por local</div>
        <ThermographyTable groups={groups} showPrevious={!!previous} classes={{ table: paper.table }} />
      </div>

      {record.notes && (
        <div className={paper.section}>
          <div className={paper.sectionTitle}>Observações</div>
          <div className={paper.noteBox}>{record.notes}</div>
        </div>
      )}

      <span className={styles.footnote}>
        ΔT = direito menos esquerdo. Diferença acima de {formatThreshold()} °C entre os lados aparece destacada.
      </span>
    </>
  );
};

export default ThermographyReportBody;
